export default __webpack_public_path__ + "static/media/12.5f2a2d3f.png";